import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
// import {BrandExpoScreen} from '@nebulr-group/nblocks-react/lib/screens/BrandExpo.screen';
import {
  NBAuthGuard,
  AuthRoutes,
  OnboardRoutes,
  UserRoutes,
  TenantRoutes,
} from '@nebulr-group/nblocks-react';

import Handover from './pages/Handover';
import { NoAppIdComponent } from './NoAppIdComponent';
import MsAzureMarketplaceLanding from './pages/MsAzureMarketplaceLanding';
import UserManagement from './pages/UserManagement';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/handover/*" element={<Handover />} />

      {/* Nblocks standard routes */}
      <Route path="/auth/*" element={<AuthRoutes />} />
      <Route path="/onboard/*" element={<OnboardRoutes />} />
      <Route path="/tenant/*" element={<TenantRoutes />} />
      <Route
        path="/user/*"
        element={
          <NBAuthGuard>
            <UserRoutes />
          </NBAuthGuard>
        }
      />
      <Route path="/ms-marketplace-landing/*" element={<MsAzureMarketplaceLanding />} />
      <Route path="/user-management/*" element={<UserManagement />} />
      {/* <Route path="/brand-expo" element={<BrandExpoScreen/>} /> */}
      <Route path="*" element={<Navigate to="/auth/login" replace={true} />} />
    </Routes>
  );
}

function HandoverRoutes() {
  return (
    <Routes>
      <Route path="/handover/*" element={<Handover />} />
      <Route path="*" element={<NoAppIdComponent />} />
    </Routes>
  );
}

export { AppRoutes, HandoverRoutes };
